import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDateTimePickerMixin from './KendoDateTimePickerMixin'

export default {
    name: 'kendo-datetimepicker',
    mixins: [ KendoDateTimePickerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('input',{
            props: {
                value: this.value
            }
        })
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateTimePicker/index.js